import {iif, Observable, of, ReplaySubject, Subject, timer} from "rxjs";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {ObjectConfig} from "../../models/ObjectConfig";
import {appInjector} from "../appInjector";
import {ToolsService} from "../../services/toolsService/tools.service";
import {isRemoveSidebar} from "../../../configs/view_only";
import {debounceTime, mergeMap, takeWhile} from "rxjs/operators";

export class FigureMainClass{
  /** @deprecated */
  public object;
  public tool;

  private _itemId;
  get itemId() {
    return this._itemId;
  }

  set itemId(value) {
    this._itemId = value;
  }

  //onlywrite
  public objectConfig: ObjectConfig;
  private objectsCanBeEdited = true;

  public dragStart = new Subject();
  public editStart = new Subject();
  // public pointAdded$ = new Subject().asObservable();
  public editStop = new Subject();
  protected _pointAdded$: Subject<number> = new Subject<number>();

  get pointAdded$(){
    return this._pointAdded$.asObservable();
  }
  public _dragEnd = new Subject();
  get dragEnd$(){
    return this._dragEnd.asObservable();
  }
  get editStop$() {
    return this.editStop.asObservable();
  }
  public hover = new Subject();
  public clickOnObject = new Subject();
  public linkedObjectsAnchor = new ReplaySubject(1);
  protected viewEntityId : any;
  protected fallbackEntityId: any;
  protected debounceObservable$ = new Observable((observer)=>{
    observer.next(true);
  });

  protected showBorderDebounce$ = new Subject<boolean>();
  protected lastDragPosition;

  // view?;
  constructor(object : ObjectConfig, protected view: CesiumAdapterService, protected toolService: ToolsService) {

    this.initTool(object);

    this.objectConfig = object;

    this.__init(object);
    if (!isRemoveSidebar){
      this.initListeners(object);

      this.updateLinkedObjectsAnchorPosition();
    }

  }

  protected setObjectConfigValue(key, val){
    let method = 'set'+key.charAt(0).toUpperCase()+key.slice(1);
    this.objectConfig[method](val);
  }

  public forceResize(config: ObjectConfig, additionalOptions?){
    throw new Error('updateFigureSizeFromConfig not implemented');
  }

  protected __init(config : ObjectConfig) {}
  protected __onServerUpdate(config : ObjectConfig) {}

  protected initListeners(config:ObjectConfig) {
    this.view.dragStart.subscribe((entityId)=>{
      if (entityId && this.viewEntityId == entityId || this.fallbackEntityId == entityId){
        this.dragStart.next(entityId);
      }
    });

    this.view.editStart.pipe(mergeMap((event) => {
      return iif(() => this.objectsCanBeEdited, of(event), of(false))
    })).subscribe((entityId) => {
      this.objectsCanBeEdited = false;
      timer(200).subscribe(() => {
        this.objectsCanBeEdited = true;
      });

      if (entityId && this.viewEntityId == entityId) {
        this.editStart.next(entityId);
      }
    });

    this.view.startRotate$.subscribe((entityId)=>{
      if (entityId && (this.viewEntityId || this.fallbackEntityId) && (this.viewEntityId == entityId || this.fallbackEntityId == entityId)){
        this.onRotateStart();
      }
    });

    this.view.dragEnd.subscribe((object: {position, id})=>{
      if (object && ((this.viewEntityId && this.viewEntityId == object.id) || (this.fallbackEntityId && this.fallbackEntityId == object.id))){
          this.onDragEnd(object);
          // this.updateLinkedObjectsAnchorPosition();
        }
    });

    this.view.clickOnObject.subscribe((object:{entityId, isCtrl})=>{
      if (object.entityId && (this.viewEntityId || this.fallbackEntityId) && (this.viewEntityId == object.entityId || this.fallbackEntityId == object.entityId)){
        this.clickOnObject.next(object);
      }
    });

    this.view.hoverOnObject.subscribe((object:{entityId, position})=>{
      if (
        (object.entityId && this.viewEntityId && this.viewEntityId == object.entityId)
        || (object.entityId && this.fallbackEntityId && this.fallbackEntityId == object.entityId)
      ){
        this.hover.next(object)
      }
    });

    config.serverUpdate.subscribe((serverConfig) => {
      this.__onServerUpdate(serverConfig);
    });

    config.subject.subscribe((config)=>{
      this.__onInternalUpdate(config);
    })
  }

  public showHoverText(text, position) {
    this.view.showHoverText(text, position);
  }

  protected __onInternalUpdate(config: ObjectConfig){}

  protected onDragEnd(object){
    this._dragEnd.next({oldPosition: null, object:object});
    throw new Error('onDragEnd not implemented');
  }

  public onRotateStart(){
    throw new Error('onRotateStart not implemented');
  }

  public rotate(degrees){
    throw new Error('rotate not implemented');
  }

  public getRotation(){
    return 0;
  }

  public stopEdit() {
    this.view.stopEditing();
  }

  protected getInitialConfig() {
    if (this.tool.hasOwnProperty('map_configs') && this.tool.map_configs.hasOwnProperty('cesium')) {
      return this.tool.map_configs.cesium;
    }
    return {};
  }

  protected initTool(object : ObjectConfig) {
    this.tool = object.getTool()
  }

  public setViewEntityId(entity : any) {
    this.viewEntityId = entity;
  }

  // note: [SHR]: difference
  // public startDrag(isCopy?){
  //   console.log('startDrag', isCopy);
  //   this.view.startDragObject(this.viewEntityId, isCopy);
  // }

  public startDrag(isMultiSelect?){
    this.view.startDragObject(this.viewEntityId, isMultiSelect);
  }

  public setObjectHighlight(flag, withNumbers?){
    if (this.viewEntityId) {
      // this.view.highlightForConcreteDrawing3DModel(this.viewEntityId);
      this.view.setObjectHighlight(this.viewEntityId, flag);
    }
    if (this.fallbackEntityId) {
      this.view.setObjectHighlight(this.fallbackEntityId, flag);
    }
    // throw new Error('setObjectHighlight not implemented');
  }

  public startEdit(withNumbers?){
    throw new Error('startEdit not implemented');
  }

  // public stopEditing(){
  //   this.view.stopEd
  // }

  public setTransparency(val){
    throw new Error('setTransparency not implemented');
  }

  public setVisibility(isVisible){
    if (this.viewEntityId) {
      this.view.setVisibility(this.viewEntityId, isVisible);
    }
  }

  public setGrayScale(val){
    throw new Error('setGrayScale not implemented');
  }

  public centerOnObject(offsetHeight?){
    throw new Error('center on object not implemented');
    // this.view.centerOnEntity(this.viewEntityId);
  }

  public removeObject(){
    if (this.view.editingEntityId && this.view.editingEntityId == this.viewEntityId){
      this.view.stopEditing()
    }
    this.view.removeObject(this.viewEntityId);
  }

  // note: [SHR]: difference
  public updateObjectPositionByMultiSelect(){
    throw new Error("updateObjectPositionByMultiSelect not implemented");
  }

  public updateObjectPosition(position){
    // console.error('updateObjectPosition');
    // this.object.position = position;
    // this.view.updateObjectPosition(this.object);
    // this.updateLinkedObjectsAnchorPosition();
  }

  public updateLinkedObjectsAnchorPosition() {
    let p = this.getLinkedObjectsAnchorPosition();
    if (p) {
      this.linkedObjectsAnchor.next(this.getLinkedObjectsAnchorPosition());
    }
  }

  public moveBy(offset){
    throw new Error("moveBy not implemented");
  }

  moveByOffsetFromOriginalPosition(offset){
    throw new Error("moveByOffsetFromOriginalPosition not implemented");
  }

  public moveWithDirection(event:KeyboardEvent){
    throw new Error("moveWithDirection not implemented");
  }

  public getLinkedObjectsAnchorPosition() {
    throw new Error("Not implemented");
    return this.object.position;
  }
  // //todo: change to protected
  // public changeObjectToFixedSize(size) {
  //   throw new Error("Fixed size is not implementable for this type of object");
  // }

  public draw() : Observable<any> {
    throw new Error("Fixed size is not implementable for this type of object");
  }

  public redraw() {

  }

  public getViewEntityId() {
    return this.viewEntityId;
  }

  public getViewFallbackEntityId() {
    return this.fallbackEntityId;
  }

  public highlightForConcreteDrawing() {}
  public removeHighlightForConcreteDrawing() {}

}

